import {DocumentId} from "common/types/document";

interface FamilyDocumentLike {
  id: DocumentId;
  dc_document_id?: number | null;
}

// Other-document clause links only apply inside a document family
export default function getFamilyDocumentId(
  document: FamilyDocumentLike | null | undefined,
): DocumentId | undefined {
  if (!document || !document.dc_document_id) {
    return undefined;
  }
  return document.id;
}
